// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external-app-widget {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--preset-card);
}

.widget-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 16px;
  color: #818384;
}

.error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  color: #ff4444;
}
.error mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.app-container {
  flex: 1;
  overflow: auto;
}
.app-container > * {
  display: block;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/external-app-widget/external-app-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,OAAA;EACA,cAAA;AAAF;AAGE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AADJ","sourcesContent":[".external-app-widget {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--preset-card);\n}\n\n.widget-content {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  gap: 16px;\n  color: #818384;\n}\n\n.error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n  color: #ff4444;\n\n  mat-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.app-container {\n  flex: 1;\n  overflow: auto;\n\n  // Allow web component to fill the container\n  > * {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
